import { render, staticRenderFns } from "./quantitatives.vue?vue&type=template&id=18fdd47a"
import script from "./quantitatives.vue?vue&type=script&lang=js"
export * from "./quantitatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports